import { FC, useState } from "react";
import { LineStylePopup } from "shared/ui";
import type { ParabolicSARSettings, IndicatorLineStyle } from "../../model";
import styles from "./ADXStylesTab.module.css";

interface Props {
  settings: ParabolicSARSettings;
  onChange: (s: ParabolicSARSettings) => void;
}

export const ParabolicSARStylesTab: FC<Props> = ({ settings, onChange }) => {
  const [open, setOpen] = useState(false);

  const updateLine = (patch: Partial<IndicatorLineStyle>) =>
    onChange({ ...settings, mainLine: { ...settings.mainLine, ...patch } });

  return (
    <div className={styles.tab}>
      <div className={styles.row}>
        <div className={styles.left}>
          <label className={styles.checkboxWrap}>
            <input
              type="checkbox"
              className={styles.checkboxInput}
              checked={settings.mainLine.visible}
              onChange={(e) => updateLine({ visible: e.target.checked })}
            />
            <span className={styles.checkmark} />
          </label>
          <span className={styles.label}>main line</span>
        </div>
        <div className={styles.btnWrap}>
          <button
            className={styles.colorBtn}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={() => setOpen((prev) => !prev)}
          >
            <span className={styles.colorBtnSwatch} style={{ background: settings.mainLine.color }} />
            <span className={styles.colorBtnWidth}>{settings.mainLine.width}px</span>
          </button>
          {open && (
            <LineStylePopup
              color={settings.mainLine.color}
              width={settings.mainLine.width}
              onColorChange={(c) => updateLine({ color: c })}
              onWidthChange={(w) => updateLine({ width: w })}
              onClose={() => setOpen(false)}
            />
          )}
        </div>
      </div>
    </div>
  );
};
